import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Loader } from '@/components/Loader/Loader';
import { AppContainer } from '@/components/AppContainer/AppContainer';
import MainPage from '@/pages/Main/MainPage';
import FriendsPage from '@/pages/Friends/FriendsPage';
import TasksPage from '@/pages/Tasks/TasksPage';
import LeaderboardPage from '@/pages/Leaderboard/LeaderboardPage';
import FortuneWheelPage from '@/pages/FortuneWheel/FortuneWheelPage';
import CasePage from '@/pages/Case/CasePage';
import VoucherPage from '@/pages/Voucher/VoucherPage';
import VoucherHistoryPage from '@/pages/Voucher/VoucherHistoryPage';
import CaseArchivePage from '@/pages/Case/CaseArchive/CaseArchivePage';
import CaseArchiveDetailed from '@/pages/Case/CaseArchive/CaseArchiveDetailed';

interface AppRouterProps {
  onWalletOpen: () => void;
}

// Компонент загрузки для Suspense
const PageLoader = () => (
  <AppContainer>
    <Loader />
  </AppContainer>
);

export const AppRouter: React.FC<AppRouterProps> = ({ onWalletOpen }) => {
  return (
    <Routes>
      <Route path="/" element={<MainPage onWalletOpen={onWalletOpen} />} />
      <Route path="/tasks" element={<TasksPage />} />
      <Route path="/friends" element={<FriendsPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/wheel" element={<FortuneWheelPage />} />
      <Route path="/case" element={<CasePage />} />
      <Route path="/voucher" element={<VoucherPage />} />
      <Route path="/voucher/history" element={<VoucherHistoryPage />} />
      <Route path="/case/archive" element={<CaseArchivePage />} />
      <Route path="/case/archive/:id" element={<CaseArchiveDetailed />} />
    </Routes>
  );
};
